import React, {useEffect, useState} from "react";
import {Container, Row, Col, Card, CardBody, CardTitle} from "reactstrap";
import {Link} from "react-router-dom";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import {withTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";
import {dashboardFilesCount} from "../../store/dashboard/actions";
import FilesCountChart from "./FilesCountChart";
import classNames from "classnames";

const Dashboard = (props) => {
  const [periodType, setPeriodType] = useState("month")

  const {filesCount} = useSelector(({Dashboard}) => ({
    filesCount: Dashboard.filesCount,
  }))

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(dashboardFilesCount({history: props.history}))
  }, [dispatch])

  document.title = "Dashboard | FileJet";

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title={props.t("FileJet")} breadcrumbItem={props.t("Dashboard")}/>
          <Row>
            <Col className="col-8">
              <Card>
                <CardBody>
                  <div className="d-sm-flex flex-wrap">
                    <CardTitle className="card-title mb-4 h4">
                      Files Count
                    </CardTitle>
                    <div className="ms-auto">
                      <ul className="nav nav-pills">
                        <li className="nav-item">
                          <Link to="#" className={classNames({active: periodType === "month"}, "nav-link")} onClick={() => {
                            setPeriodType("month")
                          }}>
                            Month
                          </Link>
                        </li>
                        <li className="nav-item">
                          <Link to="#" className={classNames({active: periodType === "year"}, "nav-link")} onClick={() => {
                            setPeriodType("year")
                          }}>
                            Year
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="clearfix"/>
                  {periodType === "month" && <FilesCountChart chartSeries={filesCount.month.data} categories={filesCount.month.categories}/>}
                  {periodType === "year" && <FilesCountChart chartSeries={filesCount.year.data} categories={filesCount.year.categories}/>}
                </CardBody>
              </Card>
            </Col>
            <Col className="col-4">
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default withTranslation()(Dashboard);
